<ng-container [formGroup]="form">

  <app-base-field-html [form]="form" [fieldData]="fieldData" [editMode]="editMode" [readonly]="readonly"
                       [hideField]="hideField" [scrollContainer]="scrollContainer" [inputId]="inputId"
                       (emitPush)="push()">

    <div [ngClass]="{'uk-disabled': readonly}">
      @if (fieldData.typeInfo.multiplicity) {

      } @else {
        <input type="checkbox" class="uk-checkbox" [ngClass]="{'uk-form-danger': checkFormValidity()}"
               [formControlName]="fieldData.name" [id]="inputId"
               (input)="updateBitSet(fieldData); unsavedChangesPrompt()"
               (focusin)="focus()" (focusout)="focusOut(true)">
        <label [for]="inputId" class="uk-checkbox-label uk-margin-small-left">{{ label }}</label>
      }
    </div>

  </app-base-field-html>

</ng-container>
